/**
 * Schedule / Events Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the Schedule & Events guide.
 */
export const scheduleTourConfig = {
  id: 'schedule-onboarding',
  storageKey: 'triad_tour_schedule_completed',
  steps: [
    {
      id: 'schedule-menu',
      target: () => {
        const el = document.querySelector('[data-tour="schedule-menu"]');
        if (el && (el.offsetWidth > 0 || el.getClientRects().length > 0)) {
          return el;
        }
        return null;
      },
      titleKey: 'tour.schedule.menuTitle',
      descriptionKey: 'tour.schedule.menuDesc',
      position: 'right',
      align: 'start',
      allowMissing: true
    },
    {
      id: 'schedule-header',
      target: '[data-tour="schedule-header"]',
      titleKey: 'tour.schedule.headerTitle',
      descriptionKey: 'tour.schedule.headerDesc',
      position: 'bottom',
      align: 'start'
    },
    {
      id: 'schedule-grid',
      target: '[data-tour="schedule-grid"]',
      titleKey: 'tour.schedule.gridTitle',
      descriptionKey: 'tour.schedule.gridDesc',
      position: 'top',
      align: 'center'
    },
    {
      id: 'schedule-add-btn',
      target: () => {
        const el = document.querySelector('[data-tour="schedule-add-btn"]');
        if (el && (el.offsetWidth > 0 || el.getClientRects().length > 0)) {
          return el;
        }
        return null;
      },
      titleKey: 'tour.schedule.addTitle',
      descriptionKey: 'tour.schedule.addDesc',
      position: 'bottom',
      align: 'end',
      allowMissing: true
    }
  ]
};

export default scheduleTourConfig;
